module.exports = __webpack_public_path__ + "img/cloud.f4b6c95c.png";